@if (marknadsomraden) {
  <rask-page pageTitle="Hantera måttslagskonvertering">
    <ng-container headerContent>
      <rask-selector
        class="col-2"
        label="Marknadsområde"
        [values]="marknadsomraden"
        aid="MarknadsomradeFilter"
        [viewFormatter]="textFormatter"
        [formatter]="idFormatter"
        [(ngModel)]="internalRequest.marknadsomradeId">
      </rask-selector>
      <rask-selector
        class="col-2"
        label="Region"
        aid="Resultatomrade"
        [values]="getResultatomraden()"
        [viewFormatter]="textFormatter"
        [formatter]="idFormatter"
        [(ngModel)]="internalRequest.resultatomradeId">
      </rask-selector>
      <rask-selector
        class="col-2"
        label="Från måttslag"
        aid="FranMattslag"
        [values]="mattslag"
        [viewFormatter]="textFormatter"
        [formatter]="idFormatter"
        [(ngModel)]="internalRequest.mattslagId"
        [canDelete]="false">
      </rask-selector>
      <rask-textmultiline
        label="Till måttslag"
        value="m3f"
        aid="TillMattslag">
      </rask-textmultiline>
      <rask-button
        color="secondary"
        aid="Visa"
        (click)="getNewMattslag()"
        [disabled]="!canFilter()">
        Visa
      </rask-button>
    </ng-container>
    <ng-container>
      <div class="row" class="text-center">
        <h3>{{ filterText }}</h3>
      </div>
    </ng-container>
    <ng-container>
      @if (mattslagResponse) {
        <div id="result">
          <div class="row">
            <div class="col-12">
              <div style="width: 100%; height: 100%">
                <rask-hot-doc
                  [hotDoc]="hotDoc">
                </rask-hot-doc>
              </div>
            </div>
          </div>
        </div>
      }
    </ng-container>
    <ng-container footerContent>
      <rask-button color="secondary"  (click)="cancelChanges()" [disabled]="!canSave()">Ångra ändringar</rask-button>
      <rask-save-button color="primary" (click)="save()" [disabled]="!canSave()"></rask-save-button>
    </ng-container>
  </rask-page>
}
